import { Platform } from 'react-native';

import { SpacingArg } from '../types';

export function resolveSpacingArg(
  arg: SpacingArg,
  spacingUnit: number,
): SpacingArg {
  return typeof arg === 'string'
    ? arg
    : Platform.OS === 'web'
    ? arg * spacingUnit
    : arg * spacingUnit;
}
